import script from "./PackageTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__